import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useCallback } from 'react';
import MealItems from '../../containers/MealItems/MealItems';
import mealsStore from '../../store/mealsStore';
import { modalStore } from 'src/mobx/modalStore';
import { IMealChoice } from 'src/types/combo';
import { getTranslate } from 'src/utils/helpers';
import './style.scss';

interface IProps {
  choice: IMealChoice;
}

const MealChoice: FC<IProps> = memo(
  observer((props: IProps): ReactElement => {
    const onEditChoice = useCallback(() => {
      if (!mealsStore.meal) return;

      modalStore.openMealChoiceEditModal({
        choiceId: props.choice.id,
        choiceName: props.choice.name,
        groupId: props.choice.group_id,
        sizes: mealsStore.meal.sizes,
        items: mealsStore.meal.items,
        onSubmit: mealsStore.onEditChoice,
        onDelete: mealsStore.onDeleteChoice,
      });
    }, [props.choice, mealsStore.meal?.sizes, mealsStore.meal?.items]);

    return (
      <div className="meal-choice mt-2">
        <button onClick={onEditChoice} className="meal-choice__title text-elipsis mr-4">
          {getTranslate(props.choice.name)}
        </button>

        <MealItems choice={props.choice} />
      </div>
    );
  })
);

export default MealChoice;
